// i18nOwl-ignore [app-typeform.triggerIntegrations.fill-form.title]
import type {TriggerIntegration} from '@cohort/merchants/apps';
import TypeformTriggerIntegrationConfigComponent from '@cohort/merchants/apps/typeform/triggerIntegrations/ConfigComponent';
import TypeformFillFormTriggerIntegrationStepCompletionContextComponent from '@cohort/merchants/apps/typeform/triggerIntegrations/fillForm/StepCompletionContextComponent';
import TypeformFillFormTriggerIntegrationStepCompletionTitleComponent from '@cohort/merchants/apps/typeform/triggerIntegrations/fillForm/StepCompletionTitleComponent';
import type {TypeformFillFormTriggerStruct} from '@cohort/shared/schema/apps/typeform/triggers/fillForm';
import {TypeformFillFormTriggerIntegrationSpec} from '@cohort/shared/schema/apps/typeform/triggers/fillForm';

export const TypeformFillFormTriggerIntegration: TriggerIntegration<TypeformFillFormTriggerStruct> =
  {
    spec: TypeformFillFormTriggerIntegrationSpec,
    configComponent: TypeformTriggerIntegrationConfigComponent,
    stepCompletionTitleComponent: TypeformFillFormTriggerIntegrationStepCompletionTitleComponent,
    stepCompletionContextComponent:
      TypeformFillFormTriggerIntegrationStepCompletionContextComponent,
  };
